/**
 * Created by hp on 2017/7/3.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {replaceNewHost} from '../../utils'

import '../../styles/classroom/ClassroomDiscussArea.css';

class ClassroomCardPopupItem extends Component {
    constructor() {
        super();
        this.handlePopupItemClick = this.handlePopupItemClick.bind(this);
        this.renderMessageContent = this.renderMessageContent.bind(this);
    }

    handlePopupItemClick() {
        this.props.onShowDiscussPanel();
    }

    renderMessageContent(subtype, content) {
        let result = '';
        switch (subtype) {
            case 'subscribe_lecture':
                result = `预约了课程${content}`;
                break;
            case 'buy_lecture':
                result = `购买了课程${content}`;
                break;
            case 'buy_channel':
                result = `购买了专栏${content}`;
                break;
            case 'follow_liveroom':
                result = `关注了直播间${content}`;
                break;
            default:
                break;
        }
        return result;
    }

    render() {
        const {message} = this.props;
        let content = this.renderMessageContent(message.subtype, message.content.target.name);
        return (
            <div className="dz-popup-item-origin">
                <div className="inline-origin" key={message.id} onClick={this.handlePopupItemClick}>
                    <div className="weui-flex">
                        <div className="weui-flex__item flex_5 card-message-popup">
                            <div className="text pop-content">
                                <p className="text-ellipsis-newline">{message.content.account.nickname}</p>
                                <p className="text-ellipsis-newline">{content}</p>
                            </div>
                        </div>
                        <div className="weui-flex__item flex_1">
                            <div className="avatar">
                                <img className="circle" alt="" src={replaceNewHost(message.content.account.small_avatar_url)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state) => ({}))(ClassroomCardPopupItem)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomCardPopupItem.js